import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useTranslate, useDataProvider } from 'react-admin';
import { Paper, Box, Button, InputBase, Typography } from '@material-ui/core';
import Checkbox from '../checkbox';
import { Search } from '@material-ui/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    list: {
        maxHeight: 320,
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
            width: '2.8px !important',
            height: "5px",
            borderRadius: "4px",
            backgroundColor: ' #c1e5fa'
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 10px white',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1e5fa',
            borderRadius: '10px'
        }
    },
    paper: {
        display: 'flex',
        justifyItems: 'center',
        height: 400,
        boxShadow: 'none'
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
}));

const FilterInput = ({ onChangeValue, value, name }) => {
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    return (
        <Box width='100%' mb={1} display='flex' borderRadius='8.1px' bgcolor='background.default'>
            <Search style={{ color: theme.palette.grey['300'], size: '18px', margin: 'auto 2px auto 5px' }} />
            <InputBase
                value={value}
                onChange={onChangeValue}
                placeholder={"Filter " + name}
                style={{ width: '180px' }}
            />
        </Box>
    )
}

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};

export default function TransferList({ setRight, setLeft, hiddenButton, readOnly, left, handleAddChannel, right }) {
    const translate = useTranslate()
    const classes = useStyles();
    const [checked, setChecked] = React.useState([]);
    const [filter, setFilter] = React.useState('')
    const [leftsFilter, setLeftFilter] = React.useState(left.filter(value => right.findIndex(element => element.id === value.id) < 0))
    const dataProvider = useDataProvider()
    const grid = 8;


    const onChangeFilter = (event) => {
        setFilter(event.target.value)
        setLeftFilter(left.filter(value => value.name.toUpperCase().search(event.target.value.toUpperCase()) > -1
            && right.findIndex(element => element.id === value.id) < 0))
    }

    const getList = id => {
        return id === 'left' ? leftsFilter : right
    };

    const handleToggle = (value, style) => () => {
        const temps = right.slice()
        const tempsfilters = leftsFilter.slice()
        if (style === 'left') {
            const index = tempsfilters.findIndex(element => element.id === value.id);
            tempsfilters.splice(index, 1)
            setLeftFilter(tempsfilters)
            temps.push(value)
            setRight(temps)
            const newChecked = [...checked];
            newChecked.push(value);
            setChecked(newChecked);
        }
        else {
            const index = right.findIndex(element => element.id === value.id);
            temps.splice(index, 1)
            setRight(temps)
            tempsfilters.push(value)
            setLeftFilter(tempsfilters)
            const newChecked = [...checked];
            newChecked.push(value);
            setChecked(newChecked);
        }

    };


    const onDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) {
            return;
        }
        if (source.droppableId === destination.droppableId) {

            const items = reorder(
                getList(source.droppableId),
                source.index,
                destination.index
            );

            if (source.droppableId === 'right') {
                setRight(items)
            }
            else {
                setLeftFilter(items)
            }


        } else {
            const result = move(
                getList(source.droppableId),
                getList(destination.droppableId),
                source,
                destination
            );
            setLeftFilter(result.left)
            // if (destination.droppableId === 'left') {
            //     let temps = left.slice()
            //     temps.push(result.left[destination.index])
            //     setLeft(temps)
            // }

            setRight(result.right)
        }

    };

    const getItemStyle = (isDragging, draggableStyle) => {
        return {
            // some basic styles to make the items look a bit nicer
            ...draggableStyle,
            padding: '0',
            ...(isDragging && {

                background: "rgb(235,235,235)"
            })

        }
    }

    const getListStyle = isDraggingOver => ({
        padding: grid,
        width: 250
    });



    if (!left) return null



    const customList = (items, style) => {


        return (
            < Droppable droppableId={style} >
                {(provided, snapshot) => (
                    <div ref={provided.innerRef}>
                        <Paper className={classes.paper}>
                            <Box>
                                {style === 'left' && <Box p={1}>
                                    <FilterInput
                                        onChangeValue={onChangeFilter}
                                        value={filter}
                                        name={"channel"} />
                                </Box>}
                                {
                                    style === 'right' ? (
                                        items.length === 0 ? <Box width={266} justifyContent='center' className={classes.paper}>
                                            <Typography style={{ marginTop: 180 }}>{translate(`pos.channels.noChannelsSelected`)}</Typography>
                                        </Box> :
                                            <List className={classes.list} component="nav" disablePadding style={getListStyle(snapshot.isDraggingOver)}>
                                                {items.map((item, index) => (
                                                    <Draggable
                                                        key={item.id}
                                                        draggableId={item.id.toString()}
                                                        index={index}>
                                                        {(provided, snapshot) => (
                                                            <div ref={provided.innerRef}>

                                                                <ListItem
                                                                    className={classes.boxBoder}
                                                                    onClick={handleToggle(item, style)}
                                                                    button
                                                                    ContainerComponent="li"


                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={getItemStyle(
                                                                        snapshot.isDragging,
                                                                        provided.draggableProps.style
                                                                    )}
                                                                >
                                                                    <Checkbox
                                                                        checked={style === 'right'}

                                                                        color='primary'
                                                                    />
                                                                    <ListItemText
                                                                        primary={item.name}
                                                                    />
                                                                </ListItem>


                                                            </div>

                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </List>
                                    ) : (
                                            <List className={classes.list} component="nav" disablePadding style={getListStyle(snapshot.isDraggingOver)}>
                                                {items.map((item, index) => (
                                                    <Draggable
                                                        key={item.id}
                                                        draggableId={item.id.toString()}
                                                        index={index}>
                                                        {(provided, snapshot) => (
                                                            <div ref={provided.innerRef}>

                                                                <ListItem
                                                                    className={classes.boxBoder}
                                                                    onClick={handleToggle(item, style)}
                                                                    button
                                                                    ContainerComponent="li"


                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={getItemStyle(
                                                                        snapshot.isDragging,
                                                                        provided.draggableProps.style
                                                                    )}
                                                                >
                                                                    <Checkbox
                                                                        checked={style === 'right'}

                                                                        color='primary'
                                                                    />
                                                                    <ListItemText
                                                                        primary={item.name}
                                                                    />
                                                                </ListItem>


                                                            </div>

                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </List>
                                        )
                                }
                            </Box>

                        </Paper>
                    </div>
                )
                }
            </Droppable >
        )

    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Box>
                <Box display='flex' justifyContent='center'>
                    <Box mr={2}>
                        {customList(leftsFilter, 'left')}
                    </Box>
                    <Box width={266}>
                        {customList(right, 'right')}
                        {
                            !hiddenButton && (
                                <Box display='flex' justifyContent='flex-end' mt={1}>
                                    <Button
                                        disabled={readOnly}
                                        variant="contained" color='primary' size='large' onClick={handleAddChannel}>
                                        {translate(`resources.room.add`)}
                                    </Button>
                                </Box>
                            )
                        }

                    </Box>

                </Box>
            </Box>


        </DragDropContext >
    );
}